<template>
    <div>
        <div class="row form-item" v-bind:key="item.key" v-for="item in items">
            <input-widget v-if="item && item.contentType == 'text/plain' " v-model="formdata[item.name]" :editable="editable" :item="item"/>
            <text-area-widget v-if="item && item.contentType == 'text/multiline' " v-model="formdata[item.name]" :editable="editable" :item="item"/>
            <boolean-widget v-if="item && item.contentType == 'text/boolean'" v-model="formdata[item.name]" :editable="editable" :item="item" />
            <integer-widget v-if="item && item.contentType == 'text/integer'" v-model="formdata[item.name]" :editable="editable" :item="item" />
            <float-widget v-if="item && item.contentType == 'text/float'" v-model="formdata[item.name]" :editable="editable"  :item="item" />
            <text-timestamp v-if="item && item.contentType == 'text/timestamp'" v-model="formdata[item.name]" :editable="editable" :item="item" />
            <datetime-widget v-if="item && item.contentType == 'text/datetime'" v-model="formdata[item.name]" :editable="editable" :item="item" :editStatus="editStatus"/>
            <date-widget v-if="item && item.contentType == 'text/date'" v-model="formdata[item.name]" :editable="editable" :item="item" />
            <list-widget v-if="item && item.contentType == 'other/list'" v-model="formdata[item.name]" :editable="editable" :item="item" :deep="deep" :editStatus="editStatus"/>
			<object-widget v-if="item && item.contentType == 'other/object'" v-model="formdata[item.name]" :editable="editable" :item="item" :deep="deep" :editStatus="editStatus"/>
            <file-widget v-if="item && item.contentType.indexOf('media/') > -1 && formdata[item.name] !== undefined" v-model="formdata[item.name]" :editable="editable"  :item="item" :deep="deep"/>
			<file-widget v-if="item && item.contentType.indexOf('media/') > -1 && formdata[item.name] === undefined" v-model="formdata" :editable="editable"  :item="item" :deep="deep"/>
            <select-widget v-if="item && item.contentType == 'other/enum'" v-model="formdata[item.name]" :editable="editable"  :item="item" />
            <Gps v-if="item && item.contentType == 'gps'" v-model="formdata[item.name]" :editable="editable"  :item="item" />
            <datamodel-widget v-if="item && item.contentType.indexOf('model') > -1" v-model="formdata[item.name]" :editable="editable" :item="item" :editStatus="editStatus"/>
            <base-data-info-widget v-if="item.contentType === 'basedatainfolist'" v-model="formdata[item.name]" :item="item" :editable="editable" :deep="deep" :index="index"/>
            <data-info-widget v-if="item.contentType === 'datainfolist'" v-model="formdata[item.name]" :item="item" :editable="editable" :deep="deep" :index="index"/>
            <vid-widget v-if="item.contentType === 'vidlist'" v-model="formdata[item.name]" :item="item" :editable="editable" :deep="deep" :index="index"/>
        </div>
    </div>
</template>


<script>
	import TextTimestamp from "./widgets/TextTimestamp"
	import IntegerWidget from "./widgets/IntegerWidget"
	import FloatWidget from "./widgets/FloatWidget"
	import InputWidget from "./widgets/InputWidget"
	import TextAreaWidget from "./widgets/TextAreaWidget"
	import BooleanWidget from "./widgets/BooleanWidget"
	import DatetimeWidget from "./widgets/DatetimeWidget"
	import DateWidget from "./widgets/DateWidget"
	import FileWidget from "./widgets/FileWidget"
	import SelectWidget from "./widgets/SelectWidget"
	import VidWidget from "./widgets/VidWidget"
	import BaseDataInfoWidget from "./widgets/BaseDataInfoWidget"
	import DataInfoWidget from "./widgets/DataInfoWidget"
	import Gps from "./widgets/Gps"


	export default {
		name: 'form-items',
		props: {
			value: { type: Object },
			items: { type: Array },
			deep: { type: Number },
			index: { type: Number},
			editable: { type: Boolean },
			editStatus: { type: String }
		},
		beforeCreate: function () {
			this.$options.components.DatamodelWidget = require('./widgets/DatamodelWidget.vue').default
			this.$options.components.ListWidget = require('./widgets/ListWidget.vue').default
			this.$options.components.ObjectWidget = require('./widgets/ObjectWidget.vue').default
		},
		components: { BaseDataInfoWidget, TextTimestamp, DataInfoWidget, Gps, VidWidget, InputWidget, TextAreaWidget, IntegerWidget, FloatWidget, BooleanWidget, DatetimeWidget, DateWidget, FileWidget, SelectWidget },
		computed: {
			formdata: {
				get() {
					return this.value
				},
				set(formdata) { this.$emit('input', formdata) }
			}
		}
	}
</script>


<style>
.form-item {
    margin-bottom: 10px;
}
.item-label {
    text-align: right;
    padding-top: 10px;
    word-break: break-word;
}
.item-content {
    margin-bottom: 5px;
}
</style>
